// @flow

const i18n = require('./i18n');

module.exports.i18n = i18n;
